import * as React from "react";
import { ButtonGroup, FormGroup } from "react-bootstrap"

import { appContext } from "../App/appContext"
import { entitetPath, IRouteComponent, FeltError, feltFeil } from "../domene"

import { ButtonLinkButton } from "./ButtonLinkButton"
import { ClickButton } from "./ClickButton"
import { navigateToRoute } from "./navigation"

import Models = Gf.Web.Models;

export function alleHandlinger<TFeltType>(
    model: Models.EntitetModell<TFeltType> | undefined,
    handler: IRouteComponent,
    clientAction: (handling: Models.HandlingType) => boolean): JSX.Element | undefined {
    return (model === undefined) ? undefined : new Handlinger<TFeltType>(model.Handlinger, handler, clientAction).alleHandlinger();
}

export function alleHandlingerEkstra<TFeltType>(
    handlinger: Models.HandlingDefinisjon[],
    handler: IRouteComponent,
    ekstraKnapper: JSX.Element[] = [],
    parameterHenter?: (handlingType: Models.HandlingType) => string | undefined): JSX.Element {
    return new Handlinger<TFeltType>(handlinger, handler, () => false).alleHandlinger(ekstraKnapper, parameterHenter);
}

let forrigeAutoklikk = [] as string[];

export class Handlinger<TFeltType> {
    constructor(
        private readonly handlinger: Models.HandlingDefinisjon[],
        private readonly handler: IRouteComponent,
        private readonly clientAction: (handling: Models.HandlingType) => boolean) { }
    alleHandlinger(
        ekstraKnapper: JSX.Element[] = [],
        parameterHenter?: (handling: Models.HandlingType) => string | undefined): JSX.Element {
        let første = !ekstraKnapper || (ekstraKnapper.length === 0);
        const autoklikk: string[] = [];
        const buttons = this.handlinger.map(h => {
            const knapp = this.handlingKnapp(h, første, parameterHenter);
            if(knapp) {
                const autoklikkId = h.Navn;
                autoklikk.push(autoklikkId);
                if (h.AutoKlikk && (forrigeAutoklikk.indexOf(autoklikkId) === -1)) {
                    appContext.setTimeout(() => this.action(h, false, parameterHenter), 1);
                }
                første = false;
            }
            return knapp;
        });
        forrigeAutoklikk = autoklikk;
        return <FormGroup><ButtonGroup>{ ekstraKnapper }{buttons}</ButtonGroup></FormGroup>;
    }

    handlingKnapp(handling: Models.HandlingDefinisjon, første: boolean, parameterHenter?: (handling: Models.HandlingType) => string | undefined): JSX.Element | null {
        // Ikke vis disabled knapper, det er bare forvirrende
        const faktiskSynlig = handling.Synlig && handling.Mulig;
        const flagg = første ? Models.HandlingFlagg.Primær : Models.HandlingFlagg.Standard;
        return faktiskSynlig
            ? (handling.LinkButtonUrl
                ? <ButtonLinkButton key={`${handling.Handling}`} flagg={flagg} to={handling.LinkButtonUrl}>{handling.Navn}</ButtonLinkButton>
                : <ClickButton key={`${handling.Handling}`}
                               flagg={flagg}
                               onClick={ () => { this.action(handling, false, parameterHenter); } }>{ handling.Navn }</ClickButton>)
            : null;
    }

    action(handling: Models.HandlingDefinisjon, bekreftet: boolean, parameterHenter?: (handling: Models.HandlingType) => string | undefined) {
        if (this.clientAction(handling.Handling)) {
            return;
        }
        const entitetHandling = handling as Models.EntitetHandlingDefinisjon;
        const entitetType = entitetHandling.EntitetType;
        const modell = {
            Id: entitetHandling .EntitetId,
            EntitetType: entitetType,
            HandlingType: handling.Handling,
            Bekreftet: bekreftet,
            ParameterJson: parameterHenter ? parameterHenter(handling.Handling) : null
        } as Models.EntitetHandlingModell;
        doPost(`/${entitetPath(entitetType) || "Start"}/Handling`,
            modell, undefined, this.handler, () => this.action(handling, true, parameterHenter));
    }
}

export function doPost<TFeltType>(url: string, modell: any, feltType: TFeltType | undefined, handler: IRouteComponent, action?: () => void) {
    appContext.post(url,
        modell,
        (resultat: Models.IHandlingResultat | null, error: Models.ApiError | null) => {
            if(resultat) {
                håndterResultat(resultat, handler, action);
            } else if(error) {
                håndterFeil(error, handler, feltType);
            }
        });
}

function håndterResultat<TFeltType>(
    resultat: Models.IHandlingResultat,
    handler: IRouteComponent,
    action: (() => void) | undefined): void {
    if(resultat.Meldinger) {
        if (!resultat.KanUtføresMedBekreftelse) {
            appContext.dialogShower.showErrorPopup(resultat.Meldinger);
        } else if(action) {
            appContext.dialogShower.showDialog(resultat.Meldinger.join("\n"), action);
        }
        return;
    }
    const handlingResultat = resultat as Models.HandlingResultat<TFeltType>;
    if(handlingResultat.Feil) {
        handler.setErrors(handlingResultat.Feil.map(f => new FeltError(`${f.Felt}`, f.Feilmelding)));
    }
    if (resultat.InvaliderRessurser) {
        for (const url of resultat.InvaliderRessurser) {
            appContext.invalidate(url);
        }
    }
    if (resultat.Url) {
        navigateToRoute(resultat.Url);
    }
}

function håndterFeil<TFeltType>(
    error: Models.ApiError,
    handler: IRouteComponent,
    feltType: TFeltType | undefined): void {
    feltFeil(error, feltType, handler);
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/Handlinger.tsx